import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { isPublicBookingRoute } from "./lib/publicBookingRoute";
import { isPublicManageRoute } from "./lib/publicManageRoute";

const root = document.getElementById("root")!;

async function bootstrapBackOffice() {
  if (!window.__SUITE_SHARED_READY__) {
    await new Promise<void>((resolve) => {
      document.addEventListener("suiteSharedReady", () => resolve(), { once: true });
    });
  }
  await import("./initRdvSuiteAuth");
  const { default: App } = await import("./App");
  const { syncSuiteUserIdFromQuery } = await import("./suiteSession");
  syncSuiteUserIdFromQuery();
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

if (isPublicManageRoute()) {
  void import("./features/public-booking/PublicManageApp").then(({ default: PublicManageApp }) => {
    createRoot(root).render(
      <StrictMode>
        <PublicManageApp />
      </StrictMode>,
    );
  });
} else if (isPublicBookingRoute()) {
  void import("./features/public-booking/PublicBookingApp").then(({ default: PublicBookingApp }) => {
    createRoot(root).render(
      <StrictMode>
        <PublicBookingApp />
      </StrictMode>,
    );
  });
} else {
  void bootstrapBackOffice();
}
